import React from 'react';

export default function Footer() {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: '0',
        textAlign: 'center',
        width: '26rem',
        left: '50%',
        marginLeft: '-13rem',
        marginTop: '1rem',
        marginBottom: '1rem',
      }}
    >
      {/* &copy; Vulcano.top 2024 */}
      &copy; 2025 Volodymyr Sheremeta, volodsher.com
    </div>
  );
}
